import { render, staticRenderFns } from "./IconPromoValentine.vue?vue&type=template&id=5ccbb65b&"
var script = {}
import style0 from "./IconPromoValentine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports